






























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';
import machineriesRepository from '@/modules/machinery/services/machineriesRepository';
import machineryProfilesRepository from '@/modules/machinery/services/machineryProfilesRepository';
import notificationService from '@/services/notificationService';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
  DxRequiredRule,
} from 'devextreme-vue/form';
import { MachineryFieldType } from '../enums';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
  },
})
export default class MachineryCreatePopup extends Vue {
    private showPopup: boolean = false;
    private saving: boolean = false;
    private profiles: IMachineryProfileListItem[] = [];

    private dto: IMachineryCreateCommand = {
      internalNumber: '',
      licensePlate: '',
      brand: '',
      type: '',
      profileId: '',
    };

    public show() {
      this.showPopup = true;
    }

    public hide() {
      this.showPopup = false;
    }

    public async save() {
      try {
        this.saving = true;
        const form: any = this.$refs.form;
        const validationResult = form.instance.validate();

        if (validationResult.isValid) {
          const result = await machineriesRepository.create(this.dto);
          notificationService.saved();
          this.$router.push({ path: `/machinery/${result.data.id}` });
        } else {
          notificationService.invalidForm();
        }
      } catch (err) {
          notificationService.showAxiosError(err);
      } finally {
        this.saving = false;
      }
    }

  private mounted() {
    this.loadProfilesAsync();
  }

  private async loadProfilesAsync() {
    this.profiles = (await machineryProfilesRepository.getAll()).data;
  }

  get profilesOptions() {
    return { items: this.profiles, displayExpr: 'name', valueExpr: 'id' };
  }
}
